import axios, { AxiosResponse, AxiosError } from "axios";
interface QueryPayload {
  query?: string; 
  user_query?: string; 
  companies_id: string | number;
  user_id?: string | number;
  offset?: string | number;
  sql?: string;
  previous_query?: string | null;
  previous_result?: any | null;
}

export const sendQueryToSQL = (
  payload: QueryPayload,
  _successCallback: (response: any) => void,
  _errorCallback: (errMessage: string) => void
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  console.log("userDetailsFromStorage:", userDetailsFromStorage);
  const query = payload.query || payload.user_query || '';
  
  const dangerousKeywords = ['replace', 'drop', 'delete', 'insert', 'update', 'truncate', 'alter'];
  const hasKeyword = dangerousKeywords.some(keyword => 
    query.toLowerCase().includes(keyword.toLowerCase())
  );
  
  if (hasKeyword) {
    _errorCallback(`Invalid query. Please provide a valid vehicle number plate, driver name, or phone number (keywords like "${query}" are not allowed).`);
    return;
  }
  
  if (!query.trim()) {
    _errorCallback('Please enter a valid search query.');
    return;
  }
  
  const formData = new FormData();

  formData.append('query', query);
  formData.append('user_query', query); 
  formData.append('companies_id', String(payload.companies_id));
  
  if (payload.user_id !== undefined) {
    formData.append('user_id', String(payload.user_id));
  }
  if (payload.offset !== undefined) {
    formData.append('offset', String(payload.offset));
  }
  if (payload.sql !== undefined) {
    formData.append('sql', payload.sql);
  }

  if (payload.previous_query) {
    formData.append('previous_query', payload.previous_query);
  }
  if (payload.previous_result) {
    formData.append('previous_result', JSON.stringify(payload.previous_result));
  }

  axios.post(`${global.api_url}/api/query_to_sql`, formData, {
    headers: {
      Authorization: `Bearer ${userDetailsFromStorage?.token}`, 
    },
  })
    .then((response: AxiosResponse) => {
      _successCallback(response.data);
    })
    .catch((error: AxiosError) => {
      const errorData: any = error.response?.data;
      const backendMsg = errorData?.message;

      if (error.response?.status === 401) {
        _errorCallback(backendMsg || "Unauthorized access");
        localStorage.clear();
      } else if (backendMsg) {
        const msg =
          typeof backendMsg === "string"
            ? backendMsg
            : JSON.stringify(backendMsg);  
        _errorCallback(msg);
      } else {
        _errorCallback(
          error.message ||
          "Something went wrong, please try again."
        );
      }
    });
};